import { useQuery } from '@tanstack/react-query';
import { useRequest } from '~/lib/useRequest';
import { config } from '~/config';
import { StaticProps } from '../context/StaticPropsContext';

export type ApplicationExportPagePropsResponse = StaticProps;

export function useApplicationExportPageProps() {
  const request = useRequest();
  const { isLoading, data, isError, error } = useQuery({
    queryKey: ['useApplicationExportPageProps'],
    queryFn: async () => {
      const response = await request<ApplicationExportPagePropsResponse>(
        `${config.apiHost}/private/v1/application_export/page_props`,
        {
          isExpectedResponse,
          method: 'GET',
        }
      );
      return response;
    },
  });

  return {
    isInitialPropsError: isError,
    initialPropsError: error,
    isLoadingInitialProps: isLoading,
    initialProps: data,
  };
}

function isExpectedResponse(res: unknown): res is ApplicationExportPagePropsResponse {
  return Boolean(res && typeof res === 'object' && 'referenceData' in res && 'defaultParameters' in res);
}
